import React from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import { Api } from '../api';
import ScribeNotification from './ScribeNotification';

const KEYS_TO_FILTERS = ['code', 'title'];

// this component does not use the redux store. if it gets more complicated it should
export default class SearchBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      searchTerm: '',
      isFocused: false,
      error: false,
      isLocked: false,
    };
  }

  searchUpdated = (term) => {
    this.setState({ searchTerm: term });
  }

  onFocus = (e) => {
    if (this.state.projects.length === 0) {
      Api.get('/api/projects?all=true').then((json) => {
        this.setState({ error: false, projects: json });
      }).catch((err) => {
        this.setState({ error: true });
      });
    }
    this.setState({ isFocused: true });
  }

  onBlur = (e) => {
    if (!this.state.isLocked) {
      this.setState({ isFocused: false });
    }
  }

  onMouseOver = (e) => {
    this.setState({ isLocked: true });
  }

  onMouseOut = (e) => {
    this.setState({ isLocked: false });
  }

  clearError = () => {
    this.setState({ error: false });
  }

  render() {
    const filteredProjects = this.state.projects.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS)).slice(0, 10);

    return (
      <div
        className="search-bar"
      >
        <ScribeNotification
          isActive={this.state.error}
          error
          message="The search tool is having a problem fetching projects. Try again momentarily."
          action={'close'}
          onClick={this.clearError}
          activeBarStyle={{ zIndex: 10000 }}
        />
        <i className="fa fa-search" aria-hidden />
        <SearchInput
          placeholder=" Search for a project"
          className="search-input"
          onChange={this.searchUpdated}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
        {this.state.isFocused ?
          <ul
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            className="search-results list-group"
          >
            {filteredProjects.map(project => (
              <li key={project.id} className="list-group-item">
                <a href={`/wfdw/projects/${project.id}`}>
                  <span className="code">{project.code}</span>{' '}
                  <span className="org-code">{project.org_code}</span>{' '}
                  <span className="title">{project.title}</span>
                </a>
              </li>
            ))}
          </ul>
          : null}
      </div>
    );
  }
}
